import styled, { css } from 'styled-components';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
import { getRadius } from '../../../foundation/theme/shape.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import { BUTTON_LINK_PADDING_SIZES } from './ButtonLink.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const ButtonLinkRoot = styled.a `
  ${({ mode, schema, size, theme, variant }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    return css `
      cursor: pointer;

      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      line-height: 1;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${getRadius(theme, 'm')};

      /* Misc */
      transition: 0.3s;
      cursor: pointer;
      text-decoration: none;

      /* Spacing */
      padding-bottom: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(BUTTON_LINK_PADDING_SIZES[size].vertical)};

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabledColor.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
export const ButtonLinkText = styled.span `
  white-space: nowrap;
`;
//# sourceMappingURL=ButtonLink.styled.js.map